/* eslint-disable no-unused-vars */
import { PlayerForSaveDto } from '@/api/models';
import styles from './PlayerTable.module.scss';

interface IPlayerTableProps {
  players: PlayerForSaveDto[];
  selectPlayer: (selectedPlayer: PlayerForSaveDto) => void;
}

function PlayerTable({ players, selectPlayer }: IPlayerTableProps) {
  return (
    <div className={styles.playerTable}>
      <div className={styles.mobilePlayerTable}>
        <div className={styles.tableHeader}>
          {/* Define method to go to player page */}
          <div className={styles.playerName}>Player Name</div>
          <div>Account</div>
          {/*<div>Status</div>
          <div>Internal Status</div>
          <div>Region</div>*/}
        </div>
        {players.map((player) => (
          <div key={player.playerId} className={styles.tableRow} role="button" onClick={() => selectPlayer(player)}>
            <div className={styles.playerName}>{player.fullName}</div>
            <div>{player.defaultTourName}</div>
            {/*<div>{player.playerBioDto.playerStatusLookupName}</div>
            <div>{player.playerBioDto.playerInternalStatusLookupName}</div>
            <div>{player.playerBioDto.playerRegionLookupName}</div>*/}
          </div>
        ))}
      </div>
    </div>
  );
}

export default PlayerTable;
